export enum AttributeDefinitionStatus {
  Unspecified = 'Unspecified',
  Inactive = 'Inactive',
  Active = 'Active',
}

export interface AttributeDefinitionQuestionOptionApi {
  Text: string;
  Value: unknown;
}

export interface AttributeQuestion {
  key: string;
  label: string;
  value: string;
  uiType: string;
}

interface AttributeInstance {
  id: number;
  questions: AttributeQuestion[];
}

export interface GroupedAttributes {
  categoryName: string;
  categoryCode: string;
  instances: AttributeInstance[];
}
